<div *ngIf="label" class="button-input-label" [ngClass]="{ 'is-disabled': disabled }">
    <p>{{ label }}</p>
</div>
<lib-button
    class="button-input--button"
    [expand]="expand"
    (onClick)="onClick()"
    [id]="id"
    borderStyle="input"
    fill="outline"
    [disabled]="disabled"
    [readonly]="readonly"
    [classes]="value ? 'has-value' : ''"
    [ngClass]="{ 'hide-overflow-text': !allowTextOverflow }">
    <div
        class="flex justify-space-between align-items-center full-width"
        [ngClass]="{ 'button-input-has-value': !!value }">
        <div class="button-input-content">
            <ion-text *ngIf="value && dateTimeFormat">
                {{ value | date: dateTimeFormat }}
            </ion-text>
            <ion-text *ngIf="value && !dateTimeFormat">
                {{ value }}
            </ion-text>
            <ion-text *ngIf="!value">{{ placeholder }}</ion-text>
        </div>
        <lib-svg-icon *ngIf="iconName" [iconName]="iconName" [size]="20" />
    </div>
</lib-button>
